export class BaseConfig {
    static mapAdapter( array: any[], fnAdapter: Function, complement?: any, complementSecond?: any ): any[] {
        return array.map((item: any) => fnAdapter( item, complement, complementSecond ));
    }
}